import { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when retailer sends referral bonus follow-up message *
 */
export const HAS_SENT_REFERRAL_BONUS_FOLLOW_UP =
  'HAS_SENT_REFERRAL_BONUS_FOLLOW_UP' as IUserMilestone.RetailerMilestone;
